import { LoadingState } from '@vista/omnichannel-components-domain';
import { isDateShowtimePickerPropsWithFilmIds } from '../utils/date-showtime-picker-utils';
export const getDefaultDateShowtimePickerState = (props) => {
    const showAllFilms = isDateShowtimePickerPropsWithFilmIds(props) ? false : props.config.allFilmsToggle.initialValue;
    return {
        oldShowtimeIdsForDate: [],
        selectedBusinessDate: undefined,
        isExternalDateTransition: false,
        filmsLoadingState: LoadingState.Loading,
        isLoadingAllFilms: false,
        showAllFilms
    };
};
